/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RemoveCompaniesRequest
 */
export interface RemoveCompaniesRequest {
  /**
   *
   * @type {string}
   * @memberof RemoveCompaniesRequest
   */
  companyListId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof RemoveCompaniesRequest
   */
  companyIds: Array<string>;
}

/**
 * Check if a given object implements the RemoveCompaniesRequest interface.
 */
export function instanceOfRemoveCompaniesRequest(
  value: object,
): value is RemoveCompaniesRequest {
  if (!("companyListId" in value) || value["companyListId"] === undefined)
    return false;
  if (!("companyIds" in value) || value["companyIds"] === undefined)
    return false;
  return true;
}

export function RemoveCompaniesRequestFromJSON(
  json: any,
): RemoveCompaniesRequest {
  return RemoveCompaniesRequestFromJSONTyped(json, false);
}

export function RemoveCompaniesRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RemoveCompaniesRequest {
  if (json == null) {
    return json;
  }
  return {
    companyListId: json["companyListId"],
    companyIds: json["companyIds"],
  };
}

export function RemoveCompaniesRequestToJSON(
  json: any,
): RemoveCompaniesRequest {
  return RemoveCompaniesRequestToJSONTyped(json, false);
}

export function RemoveCompaniesRequestToJSONTyped(
  value?: RemoveCompaniesRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyListId: value["companyListId"],
    companyIds: value["companyIds"],
  };
}
